// extracted by mini-css-extract-plugin
module.exports =  {"chipHorizonSelectorRoot":"ChipHorizonSelector-module__chipHorizonSelectorRoot--zBHgC"};